import React, { useState } from 'react';
import { Routes, Route, Link, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import { useMediaQuery } from 'react-responsive';

import '@fortawesome/fontawesome-free/css/all.min.css'; // Import Font Awesome CSS

import './App.css';

import EthanImg from './media/ethan.png';

// You'll need to create these components
import NotFound from './pages/NotFound';
import Home from './pages/Home';
import About from './pages/About';
import Resume from './pages/Resume';

import RocketProject from './pages/RocketProject';
import RobotProject from './pages/RobotProject';
import AimiProject from './pages/AimiProject';
import BattlebotProject from './pages/BattlebotProject';
import SkullCrusherProject from './pages/SkullCrusherProject';
import GokartProject from './pages/GokartProject';

import CadSkill from './pages/CadSkill';
import MachiningSkill from './pages/MachiningSkill';
import CncSkill from './pages/CncSkill';
import WeldingSkill from './pages/WeldingSkill';



const App = () => {

    const location = useLocation();

    const isActiveLink = (path) => location.pathname === path;

    const isMobile = useMediaQuery({ query: '(max-width: 900px)' });

    const [sidebarOpen, setSidebarOpen] = useState(false);

    return (
        <div className="App">
            {isMobile && !sidebarOpen && <button className="hamburger" onClick={() => setSidebarOpen(true)}><i className='fa-solid fa-bars'></i></button>}
            <nav className={`${sidebarOpen ? 'visible' : 'close'}`}>
                {isMobile && <button className="close" onClick={() => setSidebarOpen(false)}><i className='fa-solid fa-x'></i></button>}
                <p className={`navMain navItem ${isActiveLink('/') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/"><img src={EthanImg} alt="profile" className='navImg' />Ethan Freed</Link>
                </p>
                <p className={`navItem ${isActiveLink('/about') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/about">About Me</Link>
                </p>
                <p className={`navItem ${isActiveLink('/resume') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/resume">Resume</Link>
                </p>
                <p className="navItem navHeading">
                    <Link onClick={() => setSidebarOpen(false)} to="/">Projects</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/rocket') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/rocket">Hybrid Rocket "Prometheus"</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/skull-crusher') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/skull-crusher">30lb Combat Robot "Skull Crusher"</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/robot') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/robot">3lb Combat Robot "Arpox"</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/aimi') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/aimi">AIMi Consumer Toy</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/battlebot') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/battlebot">30lb Combat Robot "Apollo"</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/projects/gokart') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/projects/gokart">Go Karts (Gas & Electric)</Link>
                </p>
                {/* <p className="navItem navHeading">Skills</p>
                <p className={`navItem navIndent ${isActiveLink('/skills/cad') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/skills/cad">CAD & FEA</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/skills/machining') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/skills/machining">Traditional Machining</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/skills/cnc') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/skills/cnc">CNC Machining</Link>
                </p>
                <p className={`navItem navIndent ${isActiveLink('/skills/welding') ? 'active' : ''}`}>
                    <Link onClick={() => setSidebarOpen(false)} to="/skills/welding">Welding (TIG)</Link>
                </p> */}
            </nav>

            <main id="main-content">
                <AnimatePresence mode="wait">
                    <Routes location={location} key={location.pathname}>
                        <Route path="/" element={
                            <motion.div
                                key="home"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <Home />
                            </motion.div>
                        } />
                        <Route path="/about" element={
                            <motion.div
                                key="about"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <About />
                            </motion.div>
                        } />
                        <Route path="/resume" element={
                            <motion.div
                                key="resume"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <Resume />
                            </motion.div>
                        } />
                        <Route path="/projects/rocket" element={
                            <motion.div
                                key="rocket"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <RocketProject />
                            </motion.div>
                        } />
                        <Route path="/projects/robot" element={
                            <motion.div
                                key="robot"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <RobotProject />
                            </motion.div>
                        } />
                        <Route path="/projects/aimi" element={
                            <motion.div
                                key="aimi"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <AimiProject />
                            </motion.div>
                        } />
                        <Route path="/projects/battlebot" element={
                            <motion.div
                                key="battlebot"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <BattlebotProject />
                            </motion.div>
                        } />
                        <Route path="/projects/skull-crusher" element={
                            <motion.div
                                key="skull-crusher"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <SkullCrusherProject />
                            </motion.div>
                        } />
                        <Route path="/projects/gokart" element={
                            <motion.div
                                key="gokart"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <GokartProject />
                            </motion.div>
                        } />
                        <Route path="/skills/cad" element={
                            <motion.div
                                key="cad"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <CadSkill />
                            </motion.div>
                        } />
                        <Route path="/skills/machining" element={
                            <motion.div
                                key="machining"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <MachiningSkill />
                            </motion.div>
                        } />
                        <Route path="/skills/cnc" element={
                            <motion.div
                                key="cnc"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <CncSkill />
                            </motion.div>
                        } />
                        <Route path="/skills/welding" element={
                            <motion.div
                                key="welding"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <WeldingSkill />
                            </motion.div>
                        } />
                        <Route path="*" element={
                            <motion.div
                                key="404"
                                initial={{ opacity: 0, filter: 'blur(2px)' }}
                                animate={{ opacity: 1, filter: 'blur(0px)' }}
                                exit={{ opacity: 0, filter: 'blur(2px)' }}
                                transition={{ duration: 0.15, ease: 'easeOut' }}
                            >
                                <NotFound></NotFound>
                            </motion.div>
                        } />

                    </Routes>
                </AnimatePresence>
            </main>
        </div >
    );
};

export default App;
